import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const dot = "h-2 w-2 shrink-0 rounded-full";

type LandingSectionBadgeProps = {
  children: ReactNode;
  className?: string;
  /** Use on gradient / saturated backgrounds (e.g. CTA band). */
  variant?: "default" | "onGradient";
};

export function LandingSectionBadge({
  children,
  className,
  variant = "default",
}: LandingSectionBadgeProps) {
  if (variant === "onGradient") {
    return (
      <span
        className={cn(
          "mb-5 inline-flex items-center gap-2 rounded-full border border-white/45 bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white",
          className
        )}
      >
        <span className={cn(dot, "bg-white")} />
        {children}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "mb-5 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-primary shadow-sm shadow-primary/5",
        className
      )}
    >
      <span className={cn(dot, "bg-primary")} />
      {children}
    </span>
  );
}
